import CardStack from "./CardStack";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen w-full overflow-hidden bg-[#0d0d0d]">
      {/* Warm glow */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[420px] pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center bottom, rgba(184,66,46,0.10) 0%, transparent 68%)",
        }}
      />

      {/* Top text content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pt-28 md:pt-32 pb-0">
        <div className="flex flex-col items-center text-center">

          {/* Headline */}
          <h1
            className="text-5xl md:text-6xl lg:text-[76px] font-extrabold text-white leading-[1.04] tracking-[-0.02em] max-w-3xl"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            Software Built for Impact
          </h1>

          {/* Subtitle */}
          <p
            className="mt-5 text-sm md:text-[15px] text-[#6C7278] font-light leading-relaxed max-w-md"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            Custom software development, IT consulting, and digital marketing — delivering turnkey digital solutions for businesses and private clients.
          </p>

          {/* CTAs */}
          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <a
              href="/contact"
              className="inline-flex items-center gap-2 bg-[#B8422E] text-white px-7 py-3 text-[13px] font-semibold hover:bg-[#9E3826] hover:scale-[1.03] transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
            >
              Our Solutions
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>

      {/* Ring carousel */}
      <div className="relative z-10 w-full mt-10 pb-10">
        <CardStack />
      </div>
    </section>
  );
}
